import { motion } from "framer-motion";

export default function Reveal({
  children,
  delay = 0,
  y = 30,
  className = "",
  as = "div",
}) {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </M>
  );
}

export function MaskLines({ as = "span", lines, className = "", lineClass = "", delay = 0 }) {
  const Tag = as;
  return (
    <Tag className={className}>
      {lines.map((l, i) => (
        <span className={`mask-line ${lineClass}`} key={i}>
          <motion.span
            initial={{ y: "112%" }}
            animate={{ y: 0 }}
            transition={{
              duration: 1.05,
              delay: delay + i * 0.13,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
